import { render, staticRenderFns } from "./ProductGroupV2Report.vue?vue&type=template&id=0562c9e4&scoped=true&"
import script from "./ProductGroupV2Report.vue?vue&type=script&lang=js&"
export * from "./ProductGroupV2Report.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupV2Report.vue?vue&type=style&index=0&id=0562c9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0562c9e4",
  null
  
)

export default component.exports